/** Fallback when Geocodio has not filled marker.city. */
export function getCityAndState(address) {
  if (!address || typeof address !== "string") return address || "";
  const parts = address
    .split(",")
    .map((s) => s.trim())
    .filter(Boolean);
  if (parts.length < 2) return address;
  const last = parts[parts.length - 1];
  const state = last.replace(/\d/g, "").trim() || last;
  const city = parts[parts.length - 2];
  return `${city}, ${state}`;
}

export function cityLabelForMarker(marker) {
  return marker?.city || getCityAndState(marker?.address) || marker?.address || "";
}

function hasLocationCity(marker) {
  return Boolean(String(marker?.city ?? "").trim());
}

function matchesSearchQuery(marker, queryLower) {
  if (!queryLower) return true;
  const city = cityLabelForMarker(marker);
  return [marker.username, marker.site, city].some((v) =>
    String(v || "")
      .toLowerCase()
      .includes(queryLower),
  );
}

/** Table: no usernames → no rows; search matches username, site, city. */
export function filterMarkersForFleetTable(markersData, usernamesList, filterText) {
  if (!Array.isArray(markersData)) return [];
  if (!Array.isArray(usernamesList) || usernamesList.length === 0) {
    return [];
  }
  const set = new Set(usernamesList.map((u) => String(u).toLowerCase()));
  const query = String(filterText ?? "").trim().toLowerCase();
  return markersData.filter((m) => {
    if (!set.has((m.username || "").toLowerCase())) return false;
    return matchesSearchQuery(m, query);
  });
}

/** Map: optional usernames; pins need coordinates and a parsed site city. */
export function filterMarkersForFleetMap(markersData, usernamesList, filterText) {
  if (!Array.isArray(markersData)) return [];
  const query = String(filterText ?? "").trim().toLowerCase();
  let list = markersData.filter((m) => m.position != null && hasLocationCity(m));
  if (Array.isArray(usernamesList) && usernamesList.length > 0) {
    const set = new Set(usernamesList.map((u) => String(u).toLowerCase()));
    list = list.filter((m) => set.has((m.username || "").toLowerCase()));
  }
  if (!query) return list;
  return list.filter((m) => matchesSearchQuery(m, query));
}
